var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { SdsInputMultilingualBase } from '../_sds-input-multilingual-base';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-textarea-multilingual` is a component designed for multilingual text input.
 * It includes features such as placeholders, error messages, and adjustable resizing,
 * making it ideal for applications needing multilingual text areas.
 *
 * ### Attributes
 * - `placeholder`: Placeholder text displayed when the input is empty.
 * - `no-resize`: Disables the ability to resize the textarea.
 * - `stretch`: Stretches the textarea to fill its container.
 * - `error-message`: Displays an error message when there is a validation issue.
 *
 * @tag sds-textarea-multilingual
 */
let SdsTextareaMultilingual = (() => {
    var _SdsTextareaMultilingual_placeholder_accessor_storage, _SdsTextareaMultilingual_noResize_accessor_storage, _SdsTextareaMultilingual_stretch_accessor_storage, _SdsTextareaMultilingual_errorMessage_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-textarea-multilingual')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputMultilingualBase;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _noResize_decorators;
    let _noResize_initializers = [];
    let _noResize_extraInitializers = [];
    let _stretch_decorators;
    let _stretch_initializers = [];
    let _stretch_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    var SdsTextareaMultilingual = _classThis = class extends _classSuper {
        /**
         * Placeholder text shown when the textarea is empty.
         * Provides a hint of expected content for the user.
         *
         * Defaults to an empty string.
         *
         * @attr {string} placeholder - The placeholder text.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsTextareaMultilingual_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsTextareaMultilingual_placeholder_accessor_storage, value, "f"); }
        /**
         * Disables the ability to resize the textarea.
         * When true, users cannot manually resize the textarea in the UI.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} no-resize - If true, resizing is disabled.
         */
        get noResize() { return __classPrivateFieldGet(this, _SdsTextareaMultilingual_noResize_accessor_storage, "f"); }
        set noResize(value) { __classPrivateFieldSet(this, _SdsTextareaMultilingual_noResize_accessor_storage, value, "f"); }
        /**
         * Stretches the textarea to fill the width of its container.
         * Useful for layouts requiring the textarea to expand fully within its parent.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} stretch - If true, the textarea stretches to fill the container.
         */
        get stretch() { return __classPrivateFieldGet(this, _SdsTextareaMultilingual_stretch_accessor_storage, "f"); }
        set stretch(value) { __classPrivateFieldSet(this, _SdsTextareaMultilingual_stretch_accessor_storage, value, "f"); }
        /**
         * The error message displayed when there is a validation error.
         * Provides specific feedback to the user when input requirements are not met.
         *
         * Defaults to an empty string.
         *
         * @attr {string} error-message - The error message text.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsTextareaMultilingual_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsTextareaMultilingual_errorMessage_accessor_storage, value, "f"); }
        render() {
            if (this.getCurrentLanguage()) {
                return html `
                <sds-textarea
                    id="input"
                    value="${this.getCurrentLanguageValue()}"
                    maxlength="${this.maxLength}"
                    placeholder="${this.placeholder}"
                    hint="${this.hint}"
                    .rows="${this.rows}"
                    .maxRows="${this.maxRows}"
                    .showCount="${this.showCount}"
                    .hasClear="${false}"
                    .errorMessage="${this.errorMessage}"
                    ?invalid="${this.invalid}"
                    ?auto-resize="${this.autoResize}"
                    ?no-resize="${this.noResize}"
                    ?stretch="${this.stretch}"
                    ?disabled="${this.disabled}"
                    @focus="${() => this.handleFocus()}"
                ></sds-textarea>
            `;
            }
            else {
                return html ``;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        createInputElement() {
            const textarea = document.createElement('sds-textarea');
            textarea.noResize = true;
            if (this.autoResize) {
                textarea.autoResize = true;
            }
            if (this.rows) {
                textarea.rows = this.rows;
            }
            if (this.maxRows) {
                textarea.maxRows = this.maxRows;
            }
            return textarea;
        }
        getContentClass() {
            return 'sds-multilingual-content--textarea';
        }
        constructor() {
            super(...arguments);
            _SdsTextareaMultilingual_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, ''));
            _SdsTextareaMultilingual_noResize_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _noResize_initializers, false)));
            _SdsTextareaMultilingual_stretch_accessor_storage.set(this, (__runInitializers(this, _noResize_extraInitializers), __runInitializers(this, _stretch_initializers, false)));
            _SdsTextareaMultilingual_errorMessage_accessor_storage.set(this, (__runInitializers(this, _stretch_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            __runInitializers(this, _errorMessage_extraInitializers);
        }
    };
    _SdsTextareaMultilingual_placeholder_accessor_storage = new WeakMap();
    _SdsTextareaMultilingual_noResize_accessor_storage = new WeakMap();
    _SdsTextareaMultilingual_stretch_accessor_storage = new WeakMap();
    _SdsTextareaMultilingual_errorMessage_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTextareaMultilingual");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _noResize_decorators = [property({ attribute: 'no-resize', type: Boolean })];
        _stretch_decorators = [property({ attribute: 'stretch', type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _noResize_decorators, { kind: "accessor", name: "noResize", static: false, private: false, access: { has: obj => "noResize" in obj, get: obj => obj.noResize, set: (obj, value) => { obj.noResize = value; } }, metadata: _metadata }, _noResize_initializers, _noResize_extraInitializers);
        __esDecorate(_classThis, null, _stretch_decorators, { kind: "accessor", name: "stretch", static: false, private: false, access: { has: obj => "stretch" in obj, get: obj => obj.stretch, set: (obj, value) => { obj.stretch = value; } }, metadata: _metadata }, _stretch_initializers, _stretch_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTextareaMultilingual = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTextareaMultilingual = _classThis;
})();
export { SdsTextareaMultilingual };
